import { useState } from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { sandhillsRequest, truncateString } from '@Components/Utilities/SandhillsUtility';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Button from '@mui/material/Button';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const EventHeaderInfo = ((props) => {

    const routes = useRecoilValue(atoms.routes);
    const [showMore, setShowMore] = useState(false);
    const maxDescriptionLength = 300;
    const windowSize = useWindowSize();
    const [isSavedToWatchList, setIsSavedToWatchList] = useState(props.IsSavedToWatchList);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    }

    const removeFromWatchlist = () => {
        sandhillsRequest({
            url: routes.EventWatchlistRemove,
            method: 'post',
            data: {
                eventID: props.EventID,
                eventCategoryID: props.EventCategoryID
            },
            errorHandling: {
                showDetails: false,
                useConsole: false
            }
        }).then((data) => {
            if (data) {
                setIsSavedToWatchList(false);
            }
        });
    }

    const addToWatchlist = () => {
        sandhillsRequest({
            url: routes.EventWatchlistAdd,
            method: 'post',
            data: {
                eventID: props.EventID,
                eventCategoryID: props.EventCategoryID
            },
            errorHandling: {
                showDetails: false,
                useConsole: false
            }
        }).then((data) => {
            if (!data.IsAuthenticated) {
                window.location.href = routes.SSO + '?to=' + encodeURIComponent('https://' + window.location.hostname + routes.EventWatchlistAdd + '?EventID=' + props.EventID + '&EventCategoryID=' + props.EventCategoryID + '&to=' + encodeURIComponent(window.location.href));
            } else if (data) {
                setIsSavedToWatchList(true);
            }
        });

    }

    const getHeadArialabel = () => {
        if (props.EventTitle) {
            return translator.translate('sandhills.informationfor', [translator.translate('sandhills.tradepubwebsite.mvc.auction'), props.Name + " - " + props.EventTitle]);
        }
        else {
            return translator.translate('sandhills.informationfor', [translator.translate('sandhills.dealer'), props.Name]);
        }
    };

    return (
        <>
            <div className='event-header-info'>
                <div className='event-header-section'>
                    {!windowSize.isMobile &&
                        <>
                            <div className='upcoming-column title'>
                                <div>
                                    {props.LogoUrl &&
                                        <>
                                            <LazyLoadImage src={props.LogoUrl} className="dealer-header-title-logo" alt={props.Name ?? ''} />
                                            <br />
                                        </>
                                    }
                                    {props.Name &&
                                        <span aria-label={getHeadArialabel()}>{props.Name}</span>}
                                </div>
                            </div>
                            <div className='upcoming-column auction'>
                                <h1>{props.EventTitle}</h1>
                                {(props.StartDate || props.EndDate || props.StartTime) &&
                                    <div className='flex-column'>
                                        {props.StartDate && <span><b>{translator.translate('sandhills.startdate')}:</b>&nbsp;{props.StartDate}</span>}<br />
                                        {props.EndDate && <span><b>{translator.translate('sandhills.enddate')}:</b>&nbsp;{props.EndDate}</span>}<br />
                                        {props.StartTime && <span><b>{translator.translate('sandhills.time')}:</b>&nbsp;{props.StartTime}</span>}<br />
                                    </div>
                                }
                                {
                                    //buyers premium stuff
                                }
                                <br />
                                {showMore ?
                                    <div className='show-extra'>
                                    <div><strong>{translator.translate('Sandhills.AuctionDetails')}:</strong></div>
                                        <div className='event-description'>{props.Description}</div>
                                        {(props.InventoryType || props.CurrencyCode) &&
                                            <div className='flex-column'>
                                                <br />
                                                {props.InventoryType && <span><b>{props.InventoryTypeLabel}:</b>&nbsp;{props.InventoryType}</span>}
                                                <br />
                                                {props.CurrencyCode && <span><b>{translator.translate('sandhills.currency')}:</b>&nbsp;{props.CurrencyCode}</span>}
                                                <br />
                                            </div>}
                                        <br />
                                    <div className='show-more' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleShowMore(); } }} onClick={toggleShowMore}>{translator.translate('sandhills.showless')}</div>
                                    </div>
                                    :
                                    <div className='limited-show'>
                                    <div><strong>{translator.translate('Sandhills.AuctionDetails')}:</strong></div>
                                        <div className='event-description'>{truncateString(props.Description, maxDescriptionLength)}</div>
                                        <br />
                                    <div className='show-more' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleShowMore(); } }} onClick={toggleShowMore}>{translator.translate('sandhills.hostedstore.showmore')}</div>
                                    </div>}
                            </div>
                            <div className='upcoming-column dealer'>
                            <div><strong>{translator.translate('Sandhills.AuctionLocation')}: </strong></div>
                                <div className='event-location'>
                                    {props.LocationAddress !== translator.translate('sandhills.tradesites.mvc.variouslocations').toUpperCase() && (
                                        <>{props.Address1}&nbsp;</>
                                    )}
                                    {props.LocationAddress}
                                </div>
                                {props.BusinessPhone &&
                                    <div>
                                    <span><strong><TranslationText tKey='sandhills.phone' />: </strong></span>
                                        <a id='dealer-header-phone-link' href={'tel:' + props.UnformattedBusinessPhone} className='dealer-phone'>
                                            {props.BusinessPhone}
                                        </a>
                                    </div>}
                                {isSavedToWatchList ?
                                    <>
                                        <div className='watchlist-stuff'>
                                            <br />
                                        <div className='save-link' aria-label={translator.translate('sandhills.removefromwatchlistwithspace')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); removeFromWatchlist(); } }} onClick={(e) => removeFromWatchlist()}>
                                                <i className='fas fa-heart' />&nbsp;
                                            </div>
                                            <a href={routes.EventWatchlist} className='view-watchlist'>
                                                <i className='fas fa-list' /><TranslationText tKey='sandhills.tradesites.mvc.viewmywatchlist' />
                                            </a>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className='watchlist-stuff'>
                                            <br />
                                        <div className='save-link' aria-label={translator.translate('sandhills.addtowatchlistwithspace')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); addToWatchlist(); } }} onClick={(e) => addToWatchlist()}>
                                                <i className='far fa-heart' />&nbsp;
                                            </div>
                                            <a href={routes.EventWatchlist} className='view-watchlist'>
                                                <i className='fas fa-list' /><TranslationText tKey='sandhills.tradesites.mvc.viewmywatchlist' />
                                            </a>
                                        </div>
                                    </>
                                }
                                {(props.IsLiveOrUpcomingEvent) &&
                                    <div className='dealer-btn'><Button className='dealer-button' onClick={props.loadEventBiddingAggreement}>{translator.translate('sandhills.viewtermsandconditions')}</Button></div>}
                                {(props.InventoryUrls && props.InventoryUrls.length > 0) &&
                                    props.InventoryUrls.map((item) => <div className='dealer-btn'><Button className='dealer-button' href={item.Url}>{item.DisplayText}</Button></div>)}
                            </div>
                        </>
                    }
                    {windowSize.isMobile &&
                        <>
                            <div className='upcoming-column auction'>
                                <h1>{props.EventTitle}</h1>
                                {(props.StartDate || props.EndDate || props.StartTime) &&
                                    <div className='flex-column'>
                                        {props.StartDate && <span><b>{translator.translate('sandhills.startdate')}:</b>&nbsp;{props.StartDate}</span>}<br />
                                        {props.EndDate && <span><b>{translator.translate('sandhills.enddate')}:</b>&nbsp;{props.EndDate}</span>}<br />
                                        {props.StartTime && <span><b>{translator.translate('sandhills.time')}:</b>&nbsp;{props.StartTime}</span>}<br />
                                    </div>
                                }
                                {
                                    //buyers premium stuff
                                }
                                <br />
                                {showMore ?
                                    <div className='show-extra'>
                                    <div><strong>{translator.translate('Sandhills.AuctionDetails')}:</strong></div>
                                        <div className='event-description'>{props.Description}</div>
                                        {(props.InventoryType || props.CurrencyCode) &&
                                            <div className='flex-column'>
                                                <br />
                                                {props.InventoryType && <span><b>{props.InventoryTypeLabel}:</b>&nbsp;{props.InventoryType}</span>}
                                                <br />
                                                {props.CurrencyCode && <span><b>{translator.translate('sandhills.currency')}:</b>&nbsp;{props.CurrencyCode}</span>}
                                                <br />
                                            </div>}
                                        <br />
                                    <div className='show-more' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleShowMore(); } }} onClick={toggleShowMore}>{translator.translate('sandhills.showless')}</div>
                                    </div>
                                    :
                                    <div className='limited-show'>
                                    <div><strong>{translator.translate('Sandhills.AuctionDetails')}:</strong></div>
                                        <div className='event-description'>{truncateString(props.Description, maxDescriptionLength)}</div>
                                        <br />
                                    <div className='show-more' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleShowMore(); } }} onClick={toggleShowMore}>{translator.translate('sandhills.hostedstore.showmore')}</div>
                                    </div>}
                            </div>
                            <div className='upcoming-event-split'>
                                <div className='upcoming-column dealer'>
                                <div><strong>{translator.translate('Sandhills.AuctionLocation')}: </strong></div>
                                <div className='event-location'>
                                    {props.LocationAddress !== translator.translate('sandhills.tradesites.mvc.variouslocations').toUpperCase() && (
                                        <>{props.Address1}&nbsp;</>
                                    )}
                                    {props.LocationAddress}
                                </div>
                                    {props.BusinessPhone &&
                                        <div>
                                        <span><strong><TranslationText tKey='sandhills.phone' />: </strong></span>
                                            <a id='dealer-header-phone-link' href={'tel:' + props.UnformattedBusinessPhone} className='dealer-phone'>
                                                {props.BusinessPhone}
                                            </a>
                                        </div>}
                                    {isSavedToWatchList ?
                                        <>
                                            <div className='watchlist-stuff'>
                                                <br />
                                            <div className='save-link' aria-label={translator.translate('sandhills.removefromwatchlistwithspace')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); removeFromWatchlist(); } }} onClick={(e) => removeFromWatchlist()}>
                                                    <i className='fas fa-heart' />&nbsp;
                                                </div>
                                                <a href={routes.EventWatchlist} className='view-watchlist'>
                                                    <i className='fas fa-list' /><TranslationText tKey='sandhills.tradesites.mvc.viewmywatchlist' />
                                                </a>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className='watchlist-stuff'>
                                                <br />
                                            <div className='save-link' aria-label={translator.translate('sandhills.addtowatchlistwithspace')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); addToWatchlist(); } }} onClick={(e) => addToWatchlist()}>
                                                    <i className='far fa-heart' />&nbsp;
                                                </div>
                                                <a href={routes.EventWatchlist} className='view-watchlist'>
                                                    <i className='fas fa-list' /><TranslationText tKey='sandhills.tradesites.mvc.viewmywatchlist' />
                                                </a>
                                            </div>
                                        </>
                                    }
                                </div>
                                <div className='upcoming-column title'>
                                    <div>
                                        {props.LogoUrl &&
                                            <>
                                                <LazyLoadImage src={props.LogoUrl} className="dealer-header-title-logo" alt={props.Name ?? ''} />
                                                <br />
                                            </>
                                        }
                                        {props.Name &&
                                            <span aria-label={getHeadArialabel()}>{props.Name}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className='dealer-btn'><Button className='dealer-button' onClick={props.loadEventBiddingAggreement}>{translator.translate('sandhills.viewtermsandconditions')}</Button></div>
                            {(props.InventoryUrls && props.InventoryUrls.length > 0) &&
                                props.InventoryUrls.map((item) => <div className='dealer-btn'><Button className='dealer-button' href={item.Url}>{item.DisplayText}</Button></div>)}
                        </>
                    }
                </div>
            </div>
        </>
    )
});
export default EventHeaderInfo